"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalBlessingFrostAbilityHandler = exports.ElementalBlessingFrostActorAbilityFactory = exports.ElementalBlessingFrostAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class ElementalBlessingFrostAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalBlessingFrost;
        this.__typeName = "ElementalBlessingFrost";
    }
}
exports.ElementalBlessingFrostAbilityArgs = ElementalBlessingFrostAbilityArgs;
let ElementalBlessingFrostActorAbilityFactory = class ElementalBlessingFrostActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalBlessingFrost", "Self", 0);
    }
};
ElementalBlessingFrostActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalBlessingFrost")
], ElementalBlessingFrostActorAbilityFactory);
exports.ElementalBlessingFrostActorAbilityFactory = ElementalBlessingFrostActorAbilityFactory;
let ElementalBlessingFrostAbilityHandler = class ElementalBlessingFrostAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEffectsEffectArgs([
                new core_1.LinkedEventHandlerEffectArgs("Effect On Hit", "Chills enemies on hit", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttack", {
                    applyTo: "attacked",
                    onHitOnly: true,
                    effects: [{
                            duration: Duration_1.Duration.Turns(3),
                            effect: new core_1.ChillEffectArgs("Focus", 10),
                            percentChance: 100
                        }]
                }))
            ], false),
            supernatural: true,
        });
    }
    activate(sequence, container, ability) { }
};
ElementalBlessingFrostAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalBlessingFrost)
], ElementalBlessingFrostAbilityHandler);
exports.ElementalBlessingFrostAbilityHandler = ElementalBlessingFrostAbilityHandler;
